// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".applied-filters-container[data-v-c1ad87b2]{font-size:10px}", ""]);
// Exports
module.exports = exports;
